export function setSegments(segments) {
    return {
        type: 'SEGMENT_SET',
        payload:segments
    }
}

export function updateSegment(index,segment) {
    return {
        type: 'SEGMENT_UPDATE',
        payload:{index,segment}
    }
}



// WEBPACK FOOTER //
// ./actions/Segment.js